/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleLetterW = createReactComponent("circle-letter-w", "IconCircleLetterW", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 8l1 8l2 -5l2 5l1 -8", key: "svg-1" }]
]);

export { IconCircleLetterW as default };
//# sourceMappingURL=IconCircleLetterW.js.map
